import type { ComponentType } from 'react'
import type { HubAccent } from '@/types'

import { Leaf, Sun, Flower2 } from 'lucide-react'

type AccentClasses = {
    text: string
    bgSoft: string
    border: string
    dot: string
    ring: string
}

type HubPresentation = {
    accent: HubAccent
    icon: ComponentType<{ className?: string }>
} & AccentClasses

// Full literal class strings so Tailwind can detect and generate them.
const ACCENTS: Record<HubAccent, AccentClasses> = {
    holistic: {
        text: 'text-holistic',
        bgSoft: 'bg-holistic-soft',
        border: 'border-holistic',
        dot: 'bg-holistic',
        ring: 'ring-holistic'
    },
    lifestyle: {
        text: 'text-lifestyle',
        bgSoft: 'bg-lifestyle-soft',
        border: 'border-lifestyle',
        dot: 'bg-lifestyle',
        ring: 'ring-lifestyle'
    },
    mind: {
        text: 'text-mind',
        bgSoft: 'bg-mind-soft',
        border: 'border-mind',
        dot: 'bg-mind',
        ring: 'ring-mind'
    }
}

export const accentClasses = (accent: HubAccent): AccentClasses => ACCENTS[accent]

export const HUB_PRESENTATION: Record<string, HubPresentation> = {
    'holistic-health': { accent: 'holistic', icon: Leaf, ...ACCENTS.holistic },
    'lifestyle-balance': { accent: 'lifestyle', icon: Sun, ...ACCENTS.lifestyle },
    'mind-body': { accent: 'mind', icon: Flower2, ...ACCENTS.mind }
}

export const hubPresentation = (slug: string): HubPresentation =>
    HUB_PRESENTATION[slug] ?? HUB_PRESENTATION['holistic-health']

export const HUB_ORDER = ['holistic-health', 'lifestyle-balance', 'mind-body']

export const HUB_NAV: { slug: string; label: string }[] = [
    { slug: 'holistic-health', label: 'Holistic Health' },
    { slug: 'lifestyle-balance', label: 'Lifestyle Balance' },
    { slug: 'mind-body', label: 'Mind & Body' }
]
